module.exports = __webpack_public_path__ + "static/media/sideBarSportsbook.64726e90.svg";